import { nothing } from 'immer';
import { ReactiveVarManager } from './reactiveVarManager';
export const isUpdaterFunction = updater => {
  return typeof updater === 'function';
};
export function getDraftedUpdater(updaterOrValue, produceFn) {
  if (isUpdaterFunction(updaterOrValue)) {
    return produceFn(updaterOrValue);
  }
  const value = updaterOrValue;
  const updater = __draft => {
    if (value === undefined) {
      return nothing;
    }
    return value;
  };
  return produceFn(updater);
}
export const registerImmerFunctions = (immerReactiveVar, reactiveVar, initialValue) => {
  immerReactiveVar.reset = () => reactiveVar(initialValue);
  immerReactiveVar.onNextChange = reactiveVar.onNextChange;
  immerReactiveVar.attachCache = cache => {
    reactiveVar.attachCache(cache);
    return immerReactiveVar;
  };
  immerReactiveVar.forgetCache = reactiveVar.forgetCache;
  ReactiveVarManager.add(immerReactiveVar);
};